export const ALL_DELIVERY_METHODS = Object.freeze<DeliveryMethod[]>(['eatin', 'homedelivery', 'takeaway']);

export { WOLT_SPECIALS_CATEGORY_ID } from '../constants';

export const PURCHASABILITY_ERROR_TRANSLATIONS = {
  all_option_values_disabled: 'menu-item.purchasability-errors.all-option-values-disabled',
  too_many_disabled_option_values: 'menu-item.purchasability-errors.too-many-disabled-option_values',
};

export const UNASSIGNED_AREA_ID = '00000000-0000-0000-0000-000000000000';
